import React from "react";

import Topbar from "../../../../components/Topbar/Topbar";
import SideBar from "../../../../components/SideBar/SideBar";

import "./WeightWiseReport.css";
import WeightWiseReportChild from "./WeightWiseReportChild";

const WeightWiseReport = ({ patientData }) => {
  return (
    <div className="parent-container">
      <WeightWiseReportChild patientData={patientData} />
    </div>
  );
};

export default WeightWiseReport;
